import api from "./api";

const ContactService = {
  async submitContact(data) {
    return await api.post("/api/v1/contacts", { contact: data });
  },
};

export default ContactService;
